import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyDhX-Phn9S655tx8-h6eXLwfMt2LVD-85I",
  authDomain: "probroker-web.firebaseapp.com",
  projectId: "probroker-web",
  storageBucket: "probroker-web.firebasestorage.app",
  messagingSenderId: "473010439028",
  appId: "1:473010439028:web:e1a0d8c2d28df35d4be221",
  measurementId: "G-FNFZ3STN4H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Check if notifications are supported
const isNotificationSupported = () => {
  return 'Notification' in window && 'serviceWorker' in navigator;
};

// Get current notification permission status
const getNotificationPermissionStatus = () => {
  if (!isNotificationSupported()) {
    return 'not-supported';
  }
  return Notification.permission;
};

// Check if notifications are blocked
const areNotificationsBlocked = () => {
  return getNotificationPermissionStatus() === 'denied';
};

// Get browser-specific instructions for enabling notifications
const getNotificationInstructions = () => {
  const browser = detectBrowser();
  switch (browser) {
    case 'chrome':
      return 'To enable notifications, click the lock icon in the address bar and allow notifications for this site.';
    case 'firefox':
      return 'To enable notifications, click the shield icon in the address bar and allow notifications for this site.';
    case 'safari':
      return 'To enable notifications, go to Safari Preferences > Websites > Notifications and allow notifications for this site.';
    default:
      return 'To enable notifications, please check your browser settings and allow notifications for this site.';
  }
};

// Detect browser
const detectBrowser = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes('chrome')) return 'chrome';
  if (userAgent.includes('firefox')) return 'firefox';
  if (userAgent.includes('safari')) return 'safari';
  return 'other';
};

// Register service worker
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/'
      });
      console.log('Service Worker registered with scope:', registration.scope);
      return registration;
    } catch (error) {
      console.error('Service Worker registration failed:', error);
      throw error;
    }
  }
  throw new Error('Service Worker not supported');
};

// Initialize messaging after service worker registration
const initializeMessaging = async () => {
  try {
    if (areNotificationsBlocked()) {
      throw new Error('notifications-blocked');
    }

    const registration = await registerServiceWorker();
    const messaging = getMessaging(app);
    
    // Get the token
    const currentToken = await getToken(messaging, {
      vapidKey: "BNq_0XEVPfQjIc2lqyTa9Cn-ZMwmCadYwgCClmCBRlQU68xdA-8BQ4qVHm5GhyXiWEvbn9PTA_T5ENJQP6-JhHs",
      serviceWorkerRegistration: registration
    });

    if (currentToken) {
      console.log('Current FCM token:', currentToken);
      return { messaging, token: currentToken };
    } else {
      console.log('No registration token available.');
      return { messaging, token: null };
    }
  } catch (error) {
    console.error('Failed to initialize messaging:', error);
    throw error;
  }
};

// Request notification permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    if (!isNotificationSupported()) {
      throw new Error('notifications-not-supported');
    }

    if (areNotificationsBlocked()) {
      throw new Error('notifications-blocked');
    }

    const { messaging, token } = await initializeMessaging();

    // Check if permission is already granted
    if (Notification.permission === 'granted') {
      return { token, permission: 'granted' };
    }

    // Request permission
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      const newToken = await getToken(messaging);
      return { token: newToken, permission: 'granted' };
    } else {
      return { token: null, permission: 'denied' };
    }
  } catch (error) {
    console.error("Error getting notification permission:", error);
    return { 
      token: null, 
      permission: 'error', 
      error: error.message,
      instructions: error.message === 'notifications-blocked' ? getNotificationInstructions() : null
    };
  }
};

// Handle incoming messages when app is in foreground
export const onMessageListener = () =>
  new Promise((resolve) => {
    initializeMessaging()
      .then(({ messaging }) => {
        onMessage(messaging, (payload) => {
          console.log('Received foreground message:', payload);
          resolve(payload);
        });
      })
      .catch((error) => {
        console.error('Failed to set up message listener:', error);
        resolve(null);
      });
  });

// Track user login
logEvent(analytics, 'login', {
  method: 'email'
});

// Track property view
logEvent(analytics, 'view_property', {
  property_id: '123',
  property_type: 'residential'
});

export { 
  analytics, 
  isNotificationSupported, 
  getNotificationPermissionStatus,
  areNotificationsBlocked,
  getNotificationInstructions
}; 